var Handlebars = require('/src/melia-widget/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div>\n    <div class=\"melia-icon melia-icon-ic_directions\"></div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/components/directionsMobileCTA/directionsMobileCTA.hbs
// module id = 131
// module chunks = 1